var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h1 class=\"iq-headline\">How can we help you?</h1><form class=\"stacked-form\"><nav class=\"small-chevron-list iq-multiple-choice\"><a data-value=\"price\" class=\"js-choice\">I&rsquo;d like to know the price of this artwork</a><a data-value=\"purchase\" class=\"js-choice\">I&rsquo;d like to purchase this artwork</a><a data-value=\"student_research_question\" class=\"js-choice\">I&rsquo;m a student/researcher and I have a question</a><a data-value=\"journalist_question\" class=\"js-choice\">I&rsquo;m a journalist and I have a question</a><a data-value=\"other_question\" class=\"js-choice\">Other inquiry</a></nav></form>");;return buf.join("");
};
module.exports = template;